<div class="host-house-relation pb-6">
  <host-base-house-relation></host-base-house-relation>
  <!-- <div class="relation-container">
    <div class="left">
      加载数据中...
      <nz-spin [nzSpinning]="leftLoading" nzTip="{{ 'house.house_relation.data_loading' | translate }}">
        <host-house-relation-left-panel
          #leftCMP
          (onUnlink)="onUnlink($event)"
          (onSave)="onSave()"
          (onCreate)="onCreate($event)"
          (onRemove)="onRemove($event)"
          (onRefresh)="onRefresh($event)"
        ></host-house-relation-left-panel>
      </nz-spin>
    </div>
    <div class="right">
      加载数据中...
      <nz-spin [nzSpinning]="rightLoading" nzTip="{{ 'house.house_relation.data_loading' | translate }}">
        <host-house-relation-right-panel
          #rightCMP
          (onLink)="onLink($event)"
          (onSync)="onSync()"
          (onRefreshChannelHouses)="onRefreshChannelHouses($event)"
        ></host-house-relation-right-panel>
      </nz-spin>
    </div>
  </div> -->
</div>
